<div class="content">
<!-- 	<div class="grid grid-auto-1 grid-full-height"> -->
<!-- 		<div class="width-400 content"> -->
<!-- 			<div class="layout-auto-1-auto"> -->
<!-- 				<exg-search-bar (Search)="config.table.search($event)" [placeholder]="getRessource('SearchHolder')"> -->
<!-- 					<ng-template #rightTemplate> -->
<!-- 						<i class="search-action far fa-sync"></i> -->
<!-- 					</ng-template> -->
<!-- 				</exg-search-bar> -->
<!-- 				<div class="content"> -->
<!-- 					<exg-data-list #VCmainTable [rowSource]="mainTable" -->
<!-- 					               [selectKey]="config.table.selectKey" -->
<!-- 					               [allowSingleSelection]="true" (RowChange)="config.table.selectionChanged($event)"> -->
<!-- 						<ng-template #rowTemplate let-field> -->
<!-- 							<div class="list-row-auto-1"> -->
<!-- 								<div></div> -->
<!-- 								<div class="list-primary-text typo-small"> -->
<!-- 									{{enumSvc.getFieldCaption('Receipt', field)}} -->
<!-- 								</div> -->
<!-- 							</div> -->
<!-- 						</ng-template> -->
<!-- 					</exg-data-list> -->
<!-- 				</div> -->
<!-- 			</div> -->
<!-- 		</div> -->
<!-- 		<div class="content drawer-content"> -->

<!-- 		</div> -->
<!-- 	</div> -->
	<div class="grid cols-5">
		<!--          <h5 class="typo-small">{{def.Entity}} - {{enumSvc.getFieldCaption(def.Entity,def.FieldName)}}</h5>
							<h5 class="typo-small">{{def.ListType}}</h5>-->
		<div class="span-2 content" style="margin: 1rem;">
			<div
				cdkDropList
        #unselected="cdkDropList"
				[cdkDropListData]="config.table.unselected"
				[cdkDropListConnectedTo]="[selected]"
				(cdkDropListDropped)="config.table.drop($event)"
				cdkDropListSortingDisabled
				class="example-list content">
				<div class="example-box" *ngFor="let row of config.table.unselected; let i = index"
				     cdkDrag> {{row}} </div>
			</div>
		</div>
		<div class="span-2 content" style="margin: 1rem;">
			<div
				cdkDropList
        #selected="cdkDropList"
				class="example-list content"
				[cdkDropListData]="config.table.selected"
				[cdkDropListConnectedTo]="[unselected]"
				(cdkDropListDropped)="config.table.drop($event)"
				cdkDropListSortingDisabled>
				<div class="example-box" *ngFor="let row of config.table.selected; let i = index"
				     cdkDrag> {{row}} </div>
			</div>
		</div>
	</div>

</div>
